$(document).on('change', '#haisoShippingdate', function (e) {
  const inputHaiso = $("#haisoShippingdate");
  const elmdeliveryAlert = $("#not-allow-delivery");
  const elmCheckoutBtn = $("#form-need-salon-submit");
  const inputDate = inputHaiso.val();
  
  let cleanDateStr;
  let deliverlyDate;
  let deliverlyUnixTime;

    if (inputDate) {
      cleanDateStr = inputDate.replace(/\s*\(.*\)/, '');
      deliverlyDate = new Date(cleanDateStr);
      deliverlyUnixTime = Math.floor(deliverlyDate.getTime() / 1000);
    }
  
    const now = new Date();
    const nowUnixTime = Math.floor(now.getTime() / 1000) + (2 * 86400);
  
    const canDelivery = inputDate ? nowUnixTime < deliverlyUnixTime : true;
  
    elmCheckoutBtn.prop("disabled", !canDelivery);
  　elmCheckoutBtn.css({
  　  "cursor": canDelivery ? "unset" : "not-allowed",
  　  "pointer-events": canDelivery ? "unset" : "none"
  　});
  
    elmdeliveryAlert.css("display", canDelivery ? "none" : "");
});